/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} IntegrationsInputs */



/**
* | output |
* | --- |
* | "Integrations" |
*
* @param {IntegrationsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const integrations = /** @type {((inputs?: IntegrationsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<IntegrationsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Intégrations")
	if (locale === "de") return /** @type {LocalizedString} */ ("Integrationen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Integrazioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Интеграции")
	if (locale === "es") return /** @type {LocalizedString} */ ("Integraciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("集成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("統合")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एकीकरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Integrações")
	return /** @type {LocalizedString} */ ("Integrations")
});